import {
  CircularProgress,
  CircularProgressLabel,
  Heading,
  HStack,
  Text,
  VStack,
} from "@chakra-ui/react";
import WidgetPanel from "../dashboard/WidgetPanel";
import { useContext } from "react";
import { FormContext } from "@/providers/form";
import { shouldDisplayField } from "./SelfServeSection";
import { isFieldComplete } from "./CategoryStepper";

export const flatMapFields = (field: any, values: any) => {
  if (field.type === "ListManager") {
    // iterate over number of values in the list
    const currentList = values[field.databaseKey] || ([] as any[]);
    if (currentList.length === 0) {
      return field.children.map((childField: any) => ({
        ...childField,
        childIndex: 0,
        parentDatabaseKey: field.databaseKey,
      }));
    }
    return currentList.flatMap((_listItem: any, listItemIndex: number) => {
      return [
        ...field.children.map((child: any) => ({
          ...child,
          childIndex: listItemIndex,
          parentDatabaseKey: field.databaseKey,
        })),
      ];
    });
  }
  if (field.type === "GeneratedList") {
    return [...field.renderListFields(values)];
  }
  return field;
};

const CategoryProgress = () => {
  const { sections, values } = useContext(FormContext);

  const question_count = sections.reduce(
    (count, section) =>
      count +
      section.fields
        .filter((field: any) => shouldDisplayField(field, values))
        .flatMap((field: any) => flatMapFields(field, values)).length,
    0
  );

  const completed = sections.reduce((count, section) => {
    return (
      count +
      section.fields
        .filter((field: any) => shouldDisplayField(field, values))
        .flatMap((field: any) => flatMapFields(field, values))
        .filter((field: any) => isFieldComplete(field, values)).length
    );
  }, 0);

  const progress = Math.round((completed / question_count) * 100);

  return (
    <WidgetPanel>
      <HStack alignItems="flex-start" justifyContent="space-between">
        <HStack gap="16px">
          <CircularProgress value={progress} color="brand.primary" size="92px">
            <CircularProgressLabel>{progress}%</CircularProgressLabel>
          </CircularProgress>
          <VStack alignItems="flex-start" gap="8px">
            <Heading color="brand.gray" fontSize="14px" fontWeight="500">
              Your Progress
            </Heading>
            <Text fontSize="24px" fontWeight="500">
              {completed} out of {question_count}
            </Text>
            <Text color="brand.gray" fontSize="14px" fontWeight="500">
              Questions Answered
            </Text>
          </VStack>
        </HStack>
      </HStack>
    </WidgetPanel>
  );
};

export default CategoryProgress;
